<template>
    <b-modal
        id="page-form-answers-modal"
        :ok-title="trans(block && block.id ? 'save' : 'create')"
        :cancel-title="trans('cancel')"
        size="xl"
        no-enforce-focus
        :title="trans('form_answers')"
        @shown="onShown"
        @hidden="shown = false"
        @ok="onSave"
    >

    <b-form-group :label="trans('form')">
        <FormDropdown
            :organization="organization"
            v-model="formValues.form_id"
            :placeholder="trans('choose_a_form')"
            mode="forms"
            :disabled="busy"
            @list="onSelect"
        ></FormDropdown>
    </b-form-group>

    <b-form-group :label="trans('filters')" :disabled="!formValues.form_id">
        <b-row
            v-for="(filter, index) in formValues.filters"
            :key="index"
        >
            <b-col class="col-11">
                <b-row class="mt-1">
                    <b-col class="col-5">
                        <treeselect
                            :id="`fields${index}`"
                            :disabled="busy"
                            :options="formInputs"
                            v-model="formValues.filters[index].field"
                        />
                    </b-col>
                    <b-col class="col-2 text-center">
                        <span class="mt-2">=</span>
                    </b-col>
                    <b-col class="col-5">
                        <b-form-input
                            v-if="checkIfInput(formValues.filters[index].field)"
                            v-model="formValues.filters[index].value"
                        />
                        <b-form-select
                            v-if="checkIfDate(formValues.filters[index].field)"
                            v-model="formValues.filters[index].value"
                        >
                            <b-form-select-option value="1">{{ trans('future_date') }}</b-form-select-option>
                            <b-form-select-option value="0">{{ trans('past_date') }}</b-form-select-option>
                        </b-form-select>
                    </b-col>
                </b-row>
            </b-col>
            <b-col class="col-1">
                <b-button variant="link" class="text-danger" @click="onClickRemove(index)">
                    <i class="fa fa-fw fa-times"></i>
                </b-button>
            </b-col>
        </b-row>
        <b-form-group>
            <b-button variant="link" size="sm" @click="onClickAdd" class="mt-2">
                <i class="fa fa-fw fa-plus"></i>
                {{ trans('add') }}
            </b-button>
        </b-form-group>
    </b-form-group>

    <b-tabs v-model="tab" content-class="mt-3">
      <b-tab :title="trans('output')" :disabled="!formValues.form_id">
        <treeselect
            :id="`output-${formValues.form_id}`"
            class="mb-3"
            :disabled="busy || !formValues.form_id"
            :options="formInputs"
            @select="onOutPutSelect"
            v-model="outPutSelect"
            :placeholder="trans('placeholders')"
        />
        <b-form-textarea
            id="textarea"
            :disabled="busy || !formValues.form_id"
            v-model="formValues.outPut"
            ref="outPutTextArea"
            placeholder="Enter HTML only... u can use the placeholders above"
            rows="6"
        ></b-form-textarea>
      </b-tab>
      <b-tab :title="trans('single_output')"  :disabled="!formValues.form_id">
        <treeselect
            :id="`singleoutput-${formValues.form_id}`"
            class="mb-3"
            :disabled="busy || !formValues.form_id"
            :options="formInputs"
            @select="onOutPutSelect"
            v-model="outPutSelect"
            :placeholder="trans('placeholders')"
        />
        <b-form-textarea
            id="textarea-single-output"
            :disabled="busy || !formValues.form_id"
            v-model="formValues.singleOutPut"
            ref="singleOutPutTextArea"
            placeholder="Enter HTML only... u can use the placeholders above"
            rows="6"
        ></b-form-textarea>

        <b-form-group :label="trans('modal_title')" class="mt-2">
            <treeselect
                :id="`title-${formValues.form_id}`"
                :disabled="busy || !formValues.form_id"
                :options="formInputs"
                v-model="formValues.modalTitle"
            />
        </b-form-group>

      </b-tab>
      <b-tab :title="trans('options')"  :disabled="!formValues.form_id">
        <b-form-group :label="trans('search_fields')">
            <treeselect
                :id="`search-${formValues.form_id}`"
                :disabled="busy || !formValues.form_id"
                :options="formInputs"
                multiple
                v-model="formValues.searchFields"
            />
        </b-form-group>
        <b-form-group :label="trans('categories_field')">
            <treeselect
                :id="`category-${formValues.form_id}`"
                :disabled="busy || !formValues.form_id"
                :options="formInputs"
                v-model="formValues.categoriesField"
            />
        </b-form-group>
      </b-tab>
    </b-tabs>

    </b-modal>
  </template>

  <script>
    import FormDropdown from './../list/ListDropdown'
    import Treeselect from '@riophae/vue-treeselect'

    let blank = {
        filters: [],
        outPut: '',
        searchFields: [],
        categoriesField: []
    }

    export default {
      props: {
        organization: Object,
        page: Object,
        block: Object,
        after: Number,
      },
      data() {
        return {
          busy: false,
          error: null,
          shown: false,
          trans: trans,
          outPutSelect: null,
          tab: 0,
          formValues: this.block ? this.block.meta : blank,
          selectedForm: {}
        }
      },
      components: {
        FormDropdown,
        Treeselect,
      },
      computed: {
        isAdmin() {
          return !!this.organization && !!this.organization.auth_user
        },
        formInputs() {
            if (!this.selectedForm.new_form) return []
            return this.selectedForm.new_form.form_questions
        },
      },
      watch: {
        block(){
            this.formValues = this.block && this.block.meta ? this.block.meta : blank
        }
      },
      methods: {
        checkIfInput(id) {
            if (!this.selectedForm.new_form) return true
            let field = _.find(this.selectedForm.new_form.form_questions, {id: id})
            if (field && field.type != 'date') {
                return true
            }
            return false
        },
        checkIfDate(id) {
            if (!this.selectedForm.new_form) return false
            let field = _.find(this.selectedForm.new_form.form_questions, {id: id})
            if (field && field.type == 'date') {
                return true
            }
            return false
        },
        onSelect(form) {
          if (this.formValues.filters && this.formValues.filters.length == 0) {
            this.formValues.filters.push({
                field: null,
                value: null,
            });
          }
          this.selectedForm = form
        },
        onClickRemove(index) {
          this.formValues.filters.splice(index, 1)
        },
        onClickAdd() {
          this.formValues.filters.push({
                field: null,
                value: null,
            })
        },
        onSave(e) {
            e.preventDefault()
            this.busy = true
            this.error = null
            let url = `/organization/${this.organization.id}/page/${this.page.id}/block`
            if (this.block && this.block.id) url += `/${this.block.id}`
            let data = {
                type: 'form-answers',
                meta: this.formValues,
                after: this.after,
            }
            axios[this.block && this.block.id ? 'patch' : 'post'](url, data)
            .then(response => {
                this.busy = false
                this.$emit('saved', response.data)
                this.$bvModal.hide('page-form-answers-modal')
            })
            .catch(error => {
                this.busy = false
                this.error = _.errorFromAjax(error)
            })
        },
        onShown() {

        },
        onOutPutSelect(node) {
            if (this.$refs.outPutTextArea) {
                let cursorPos = this.$refs.outPutTextArea.selectionEnd
                let text = `{ ${node.label} }`

                this.formValues.outPut = this.formValues.outPut.substring(0, cursorPos) + text + this.formValues.outPut.substring(cursorPos)

                cursorPos += text.length
                this.$refs.outPutTextArea.focus()
                this.$nextTick(() => this.$refs.outPutTextArea.focus())
                this.outPutSelect = null
            }
        },
      },
      mounted() {
        window.pageFormAnswersEventModal = this
      },
    }
  </script>
